import Guard from '@/services/middleware'

const Login = () => import('@/views/auth/Login.vue')
const Logoff = () => import('@/views/auth/Logoff.vue')
const Register = () => import('@/views/auth/Register.vue')
const Remember = () => import('@/views/auth/Remember.vue')
const AuthLayout = () => import('@/layouts/AuthLayout.vue')
const RedirectLogin = () => import('@/views/auth/RedirectLogin.vue')

export default [
    {
        path: '/login',
        component: AuthLayout,
        beforeEnter: [
            Guard.checkResellerData,
            () => {
                const isReseller =  (import.meta.env?.VITE_APP_RESELLER ?? false) === 'true'
                const local = window.origin.includes('localhost')
                if (isReseller || local) return
                // if (local) return

                window.location.href = `/v3/login`
            }
        ],
        children: [{ path: '', name: 'auth.login', component: Login, meta: { title: 'Login' } } ],
    },
    {
        path: '/forceLogin',
        component: RedirectLogin,
        beforeEnter: [ Guard.checkResellerData, Guard.checkExistsToken ],
    },
    {
        path: '/logoff',
        component: Logoff,
        beforeEnter: [Guard.checkIfLogin],
        name: 'auth.logoff',
        meta: { title: 'Saindo da conta...' },
    },
    {
        path: '/esqueci-minha-senha',
        component: AuthLayout,
        beforeEnter: [Guard.checkResellerData],
        children: [{ path: '', name: 'auth.remember', component: Remember, meta: { title: 'Esqueci minha senha' } }],
    },
    {
        path: '/cadastrar',
        component: AuthLayout,
        beforeEnter: [Guard.checkResellerData],
        children: [{ path: '', name: 'auth.register', component: Register, meta: { title: 'Cadastrar' } }],
    },
]
